module.exports = __webpack_public_path__ + "static/media/banner-image.5a9e029d.jpeg";